import { Component, OnInit, Output, EventEmitter, HostListener, ViewChild } from '@angular/core'
import { faCoffee, faBars, faLock } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { AuthenticationService } from 'src/app/core/authentication/authentication.service'
import { ResetPasswordComponent } from './resetPassword/reset-password.component'
import { first, finalize } from 'rxjs/operators'
import notify from 'devextreme/ui/notify'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  applicationTitle = (window as any).env.ApplicationTitle
  tooltipUserVisible: boolean
  faCoffee = faCoffee
  faBars = faBars
  faUser = faUser
  faLock = faLock
  username: string
  userid: string
  name: string
  roles: string
  loading: boolean

  @ViewChild(ResetPasswordComponent, { static: true }) resetPassword: ResetPasswordComponent

  constructor(private authenticationService: AuthenticationService) {}
  @Output() toggle: EventEmitter<null> = new EventEmitter()
  @Output() collapse: EventEmitter<null> = new EventEmitter()

  @HostListener('toggleSidebar')
  toggleSidebar() {
    this.toggle.emit()
  }

  @HostListener('collapseSidebar')
  collapseSidebar() {
    this.collapse.emit()
  }

  ngOnInit() {
    this.tooltipUserVisible = false
    this.username = this.authenticationService.getUsername()
  }

  logout() {
    this.loading = true
    this.authenticationService
      .logout()
      .pipe(
        first(),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        () => {},
        (response) => {
          notify(response.error.message, 'error', 600)
        }
      )
  }

  toggleTooltipUser() {
    this.tooltipUserVisible = !this.tooltipUserVisible
  }

  changePassword() {
    this.resetPassword.showModal()
  }
}
